import {trackError} from "./error_tracker"
// import { useNavigate } from "react-router-dom";
// const navigate = useNavigate();
/**
 * Function to validate if a string is a valid JSON
 * @param {string} text - The string to be tested
 * @returns {boolean} - True if the string is valid JSON, otherwise false
 */
export function isValidJson(text) {
    if (!text) return false; // Return false if the text is empty
    try {
        JSON.parse(text); // Attempt to parse the string as JSON
        return true;
    } catch (error) {
        console.error("Invalid JSON:", error); // Log the parsing error
        return false;
    }
}

/**
 * Function to make a server call using fetch API
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
 * @param {string} apiUrl - API endpoint URL
 * @param {object} data - Request body for POST, PUT, DELETE
 * @param {string} content_type - application/json, 'multipart/form-data'  
 * @param {string} [authToken] - Authorization token (optional)
 * @returns {Promise<object>} - The response data from the server
 */
export async function apiCall(method, apiUrl, data, content_type = 'application/json', authToken = localStorage.getItem("jsondata")) {
    try {
        // Parse authToken if present
        if (authToken) {
         
            //navigate("/login");
            // if(localStorage.login!==1){
            //     navigate("/login");
            //     return;
            // }
            
            const jsonData = JSON.parse(authToken);
            authToken = jsonData.accessToken || "";
            if (apiUrl.includes("refresh-access-token") || apiUrl.includes("logout")) {
                authToken = jsonData.refreshToken;
            }
        }
        
        // Set up the fetch options
        const fetchOptions = {
            method,
            headers: {
                'Authorization': 'Bearer ' + authToken,
            },
        };

        // Handle different content types
        if (method !== "GET") {
            if (content_type === 'application/json') {
                fetchOptions.headers['Content-Type'] = content_type;  // Set header only for JSON requests
                fetchOptions.body = JSON.stringify(data);
            } else if (content_type === 'multipart/form-data') {
                // Create FormData and append the data
                const formData = new FormData();
                
                // Append each key-value pair to FormData
                Object.keys(data).forEach((key) => {
                    formData.append(key, data[key]);
                });

                // For debugging: log the FormData contents
                for (let pair of formData.entries()) {
                    console.log(pair[0]+ ', ' + pair[1]);
                }

                fetchOptions.body = formData;
                // No need to manually set 'Content-Type' for multipart/form-data
            } else {
                // For any other content type, set the headers and body accordingly
                fetchOptions.headers['Content-Type'] = content_type;
                fetchOptions.body = data;
            }
        }

        // Make the fetch request
        const response = await fetch(apiUrl, fetchOptions);
        // Check for HTTP errors
        if(response.status===401){
           // window.location.href="#/login"
            return;
        }
        // if (!response.ok) {
        //     console.error(`Error: ${response.status} - ${response.statusText}`);
        //     trackError(`HTTP Error:<br/>URL:${apiUrl}<br/>Method:${method}<br>`, response.status);
        // }

        // Parse and validate the response
        const responseData = await response.json();
        if (!isValidJson(JSON.stringify(responseData))) {
            trackError(`The API response is invalid:<br/>URL:${apiUrl}<br/>Method:${method}<br>`, JSON.stringify(responseData));
        }

        return responseData;
    } catch (error) {
        trackError(`The server API request was unsuccessful:<br/>URL:${apiUrl}<br/>Method:${method}<br>`, error);
    }
}



/**
 * Function to make a server call using fetch API with async/await
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
 * @param {string} apiUrl - API endpoint URL
 * @param {object} data - Request body for POST, PUT, DELETE
 * @param {string} content_type - application/json, 'multipart/form-data' 
 * @param {string} [authToken] - Authorization token (optional)
 * @returns {Promise<object>} - The response data from the server
 */
export async function apiCallAsync(method, apiUrl, data, content_type='application/json',authToken = localStorage.getItem("jsondata")) {
    return await apiCall(method, apiUrl, data,content_type,authToken);
}

